<script setup lang="ts">
/** Bouton icône seule. Cible tactile de 48 px ; le libellé est obligatoire (lecteurs d'écran). */
import type { IconName } from '../icons/registry'
import Icon from './Icon.vue'

withDefaults(
  defineProps<{
    icon: IconName
    label: string
    variant?: 'plain' | 'surface'
    disabled?: boolean
  }>(),
  { variant: 'plain', disabled: false },
)
</script>

<template>
  <button
    type="button"
    :aria-label="label"
    :disabled="disabled"
    :class="[
      'inline-flex size-touch shrink-0 items-center justify-center rounded-full transition-colors duration-80 ease-standard',
      disabled ? 'text-ink-disabled' : 'text-ink',
      variant === 'surface' ? 'bg-surface active:bg-surface-strong' : 'active:bg-surface',
    ]"
  >
    <Icon :name="icon" :size="24" />
  </button>
</template>
